import type { ProjectWithTasks, Repository } from '~/types';

import { apiRequest } from './client';
import { ENDPOINTS, HTTP_METHODS } from './config';

export async function createRepository(data: {
  description?: string;
  name: string;
  owner: string;
}): Promise<Repository> {
  const response = await apiRequest<Repository>(ENDPOINTS.REPOSITORIES, {
    method: HTTP_METHODS.POST,
    body: JSON.stringify(data),
  });
  return response.data;
}

export async function getRepositories(): Promise<Repository[]> {
  const response = await apiRequest<Repository[]>(ENDPOINTS.REPOSITORIES);
  return response.data;
}

export async function getRepository(id: string): Promise<Repository> {
  const response = await apiRequest<Repository>(`${ENDPOINTS.REPOSITORIES}/${id}`);
  return response.data;
}

export async function getRepositoryProjects(id: string): Promise<ProjectWithTasks[]> {
  const response = await apiRequest<ProjectWithTasks[]>(`${ENDPOINTS.REPOSITORIES}/${id}/projects`);
  return response.data;
}
